"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

interface CitizensRotateProps {
  className?: string;
}
export function CitizensRotate({ className }: CitizensRotateProps) {
  const [imageNumber, setImageNumber] = useState<number | null>(null);

  useEffect(() => {
    const random = Math.floor(Math.random() * 11) + 1;
    setImageNumber(random);
  }, []);
  return (
    <>
      {imageNumber && (
        <Image
          src={`/banner/${imageNumber}.png`}
          width={1000}
          height={1000}
          quality={100}
          alt="Mulher sorrindo"
          className={className}
          priority
        />
      )}
    </>
  );
}
